import topStores from './topStores';

export default topStores;
